module.exports = __webpack_public_path__ + "img/web_account_info3_1.ad8dc8d9.png";